import { LinearGradient } from 'expo-linear-gradient'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { Image, StyleSheet } from 'react-native'

import { useRouter } from 'expo-router'

import CheckIcon from '../../../assets/check-icon.svg'
import CrownGradient from '../../../assets/crown-gradient.png'
import { DS } from '../../../design-system'
import { capitalizeFirstLetter } from '../../../utils/formatString'

export type membershipType = {
  type?: string
  price?: number
  description?: string
  stripeProductId?: string
}
interface MembershipCardProps {
  isCheckout?: boolean
  isUpdate?: boolean
  membership?: membershipType
  onSelect?: () => void
}

const MembershipCard = observer(({ isCheckout, membership, isUpdate, onSelect }: MembershipCardProps) => {
  const router = useRouter()
  const descriptionArray = membership?.description?.split(',') ?? []

  return (
    <LinearGradient
      colors={['#FF3ED4', '#480D93', '#7B043D', '#FF7222', '#E9E238']}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 1 }}
      style={styles.gradientBorder}
    >
      <DS.Frame style={styles.cardContent}>
        <DS.Frame style={styles.cardHeader}>
          <DS.Frame>
            {isCheckout && <DS.Text variant="Body Small/Regular">Premium</DS.Text>}
            <DS.Text variant="Heading 2/Medium">{capitalizeFirstLetter(membership?.type?.toLowerCase() || '')}</DS.Text>
            {!isCheckout && (
              <DS.Text variant="Body Small/Regular">{`${isUpdate ? '+' : ''}$${Math.floor(
                (membership?.price || 0) / 100
              )}/mo.`}</DS.Text>
            )}
          </DS.Frame>
          {isCheckout && <Image style={styles.crownImage} source={CrownGradient} />}
        </DS.Frame>
        <DS.Frame style={styles.featureContainer}>
          {[...descriptionArray, 'Auto-renewable Monthly Subscription'].map((feature, index) => (
            <DS.Frame key={index} style={styles.descriptionItemContainer}>
              <CheckIcon fill={DS.palette['Brand/Purple']} />
              <DS.Text variant="Body Small/Regular">{feature}</DS.Text>
            </DS.Frame>
          ))}
        </DS.Frame>
        <DS.Frame style={styles.selectButonContainer}>
          {!isCheckout && (
            <DS.Button
              variant="Medium/Primary"
              type="On Light"
              onPress={() => {
                if (isUpdate) {
                  return console.log('upgrade')
                }
                !!onSelect && onSelect()

                router.navigate(`/lobby/join-premium-checkout?membershipType=${membership?.type}`)
              }}
            >
              {isUpdate ? 'Upgrade' : 'Select'}
            </DS.Button>
          )}
          {!isUpdate && <DS.Text variant="Caption/Regular">Cancel anytime</DS.Text>}
        </DS.Frame>
      </DS.Frame>
    </LinearGradient>
  )
})

const styles = StyleSheet.create({
  gradientBorder: {
    borderRadius: 16,
    padding: 8,
    marginTop: 12
  },
  cardHeader: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  cardContent: {
    backgroundColor: 'white',
    borderRadius: 8,
    padding: 20,
    alignItems: 'flex-start'
  },
  crownImage: {
    height: 34,
    width: 44
  },
  planTitle: {
    fontSize: 24,
    fontWeight: 'bold'
  },
  planPrice: {
    fontSize: 18,
    marginVertical: 10
  },
  featureContainer: {
    marginTop: 16,
    marginBottom: 26
  },
  featureText: {
    fontSize: 16,
    marginBottom: 5
  },
  selectButonContainer: {
    alignItems: 'center',
    width: '100%',
    gap: 8
  },
  selectButton: {
    backgroundColor: 'black',
    borderRadius: 50,
    paddingVertical: 10,
    paddingHorizontal: 40,
    marginBottom: 8
  },
  selectButtonText: {
    color: 'white',
    fontSize: 16
  },
  cancelText: {
    color: 'gray'
  },
  descriptionItemContainer: {
    flexDirection: 'row'
  }
})

export default MembershipCard
